<template>
  <basic-card class="global-basic-card" padding hideHeader :hasMore="showMore">
    <avue-crud
      class="global-table"
      :option="option"
      v-model:search="search"
      :table-loading="loading"
      :data="data"
      ref="crud"
      v-model="form"
      :permission="permissionObj"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      v-model:page="page"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template #search-menu>
        <div class="search-menu-box">
          <div class="global-flex-center">
            <comp-button type="info" icon="icon-search" @click.stop="handleSearch()"
              >{{ Lang.btn.search }}
            </comp-button>
            <comp-button type="text" @click.stop="handleEmpty()">{{ Lang.btn.empty }} </comp-button>
          </div>
        </div>
      </template>
      <template #picture="scope">
        <div style="width: 60px;height:60px;" v-if="scope.row.picture">
          <el-avatar shape="square" :size="60" fit="fit" :src="scope.row.picture" />
        </div>
      </template>

      <template #header>
        <div class="search-menu-box-others" v-if="showMore">
          <comp-button
            v-if="permissionObj.add"
            type="primary"
            icon="icon-add"
            @click.stop="handleAddModel()"
            >{{ Lang.Button.modelAddModel }}
          </comp-button>
        </div>
      </template>

      <!-- 操作菜单按钮 -->
      <template #menu="{row}">
        <div class="operation-btns">
          <CompIconButton :auth="permissionObj" type="view" @click="handleModelEditOrView(row, 'view')" :divider="row.createTenant == userInfo.tenant_id" :text="Lang.tips.viewData" > </CompIconButton>
          <CompIconButton :auth="permissionObj" v-if="row.createTenant == userInfo.tenant_id" type="edit" @click="handleModelEditOrView(row, 'edit')"> </CompIconButton>
          <CompIconButton :auth="permissionObj" type="duplicate" :text="Lang.Button.modelDuplicate" :divider="row.createTenant == userInfo.tenant_id" @click="handleDuplicate(row, 'duplicate')"> </CompIconButton>
          <CompIconButton :auth="permissionObj" v-if="row.createTenant == userInfo.tenant_id" type="alarmSetting" :text="Lang.Title.modelAlarmSet" @click="handleAlarmSetting(row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" v-if="row.createTenant == userInfo.tenant_id" type="delete" :divider="false" @click="handleDel(row)" > </CompIconButton>
        </div>
      </template>
    </avue-crud>

    <!-- 新增、编辑 设备模型 弹窗 -->
    <el-drawer
      :title="operationType == 'add' ? Lang.Button.modelAddModel : operationType=='view' ? Lang.Button.modelDetail : Lang.Title.modelEditModel"
      append-to-body
      v-model="modelDialog"
      class="dataModel-selectpoints-dialog global-dialog-edit"
      size="90%"
    >
      <el-form v-if="modelDialog" :model="modelForm" :rules="rules" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12" style="display: flex; align-items: center; width: 100%">
            <el-form-item label="" prop="picture">
              <el-upload
                style="width: 60px;height:60px;"
                class="avatar-uploader"
                action="/api/blade-resource/oss/endpoint/put-file"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :on-remove="handleRemove"
                :disabled="isModelView"
                :headers="{
                  'Blade-Requested-With': 'BladeHttpRequest',
                  'Tenat-Id': userInfo.tenant_id,
                  'Blade-Auth': 'bearer ' + token,
                }"
              >
                <div class="upload-img-wrap" style="display: flex; position: relative;">
                  <div v-if="modelForm.picture && !isModelView" class="delete-icon" @click.stop="handleRemove">
                    <comp-svg name="delete" fill="#ffffff"></comp-svg>
                  </div>
                  <img v-if="modelForm.picture" :src="modelForm.picture" class="avatar" />
                  <el-avatar v-else shape="circle" :size="60" fit="contain">
                    <span class="cloud">
                      <span class="cloud-inner">
                        <comp-svg name="upload-cloud"></comp-svg>
                      </span>
                    </span>
                  </el-avatar>
                </div>
              </el-upload>
            </el-form-item>
            <div style="align-items: center; width: 100%; margin-left: 20px">
              <el-form-item :label="Lang.Title.modelModel" prop="name">
                <el-input
                  :disabled="isModelView"
                  clearable
                  style="width: 100%"
                  maxlength="100"
                  v-model="modelForm.name"
                  :placeholder="Lang.tips.plzInput + Lang.Title.modelModel"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="Lang.Title.modelDeviceType" prop="iotProduct">
              <el-select
                :disabled="isModelView"
                clearable
                v-model="modelForm.iotProduct"
                :placeholder="Lang.tips.plzInput + Lang.Title.modelDeviceType"
                style="width: 100%"
                @change="getDeviceTypeCode"
              >
                <el-option
                  v-for="(item, i) in deviceTypeList"
                  :key="item.id"
                  :value="item.dictKey"
                  :label="item.i18nValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="Lang.Title.deviceTypeCode" prop="deviceTypeCode">
              <el-select
                :disabled="isModelView"
                clearable
                v-model="modelForm.deviceTypeCode"
                :placeholder="Lang.tips.plzInput + Lang.Title.deviceTypeCode"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, i) in deviceTypeCodeList"
                  :key="item.id"
                  :value="item.dictKey"
                  :label="item.i18nValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="Lang.Title.modelCommuProtocol" prop="protocol">
              <el-select
                :disabled="isModelView"
                clearable
                v-model="modelForm.protocol"
                :placeholder="Lang.tips.plzSelect + Lang.Title.modelCommuProtocol"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, i) in protocolList"
                  :key="item.id"
                  :value="item.dictKey"
                  :label="item.i18nValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="Lang.Title.modelManufacturer" prop="manufacturer">
              <el-input
                :disabled="isModelView"
                clearable
                v-model="modelForm.manufacturer"
                maxlength="200"
                :placeholder="Lang.tips.plzInput + Lang.Title.modelManufacturer"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="Lang.Title.modelDescription" prop="description">
              <el-input
                :disabled="isModelView"
                clearable
                v-model="modelForm.des"
                type="textarea"
                maxlength="2000"
                :placeholder="Lang.tips.plzInput + Lang.Title.modelDescription"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"> </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="Lang.Title.modelPoint">
              <el-input
                v-model="modelForm.measurementPoint"
                clearable
                :placeholder="Lang.tips.plzInput + ' ' + Lang.Title.modelPoint"
                @input="filterTableData"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <template #label=""> <span style="opacity: 0;">.</span> </template>
              <el-input
                key="measurementPointIds"
                v-model="modelForm.measurementPointIds"
                clearable
                :placeholder="Lang.Text.modelSearchPointIds"
                @input="filterTableDataB"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="" style="margin-top: 30px;">
              <comp-button v-if="operationType!='view'" type="primary" @click="handleAddMeasurementPoint" >{{ Lang.Title.modelAddPoint }}</comp-button >
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 查看编辑测量点 已经选中的测量点表格 modelForm.modelItemList-->
        <el-row :gutter="20">
          <el-table
            :data="tableData"
            :tableKey="tableKey"
            class="table"
            highlight-current-row
            cell-class-name="table-row"
            header-cell-class-name="table-header"
            :show-overflow-tooltip="true"
          >
            <el-table-column prop="sid" :label="Lang.Title.modelId"></el-table-column>
            <el-table-column prop="stype" :label="Lang.Title.standardPointType"></el-table-column>
            <el-table-column prop="name" :label="Lang.Title.modelPoint"></el-table-column>
            <el-table-column prop="datatypeName" :label="Lang.Title.modelFormat"></el-table-column>
            <el-table-column prop="unit" :label="Lang.Title.modelUnit"></el-table-column>
            <el-table-column prop="itemEnum" for="" :label="Lang.Title.modelEnumDef">
              <template #default="{ row, $index }">
                <el-input
                  :disabled="isModelView"
                  v-model="modelForm.modelItemList[modelForm.modelItemList.findIndex(item => item.id == row.id)].itemEnum"
                  :placeholder="Lang.tips.plzInput + Lang.Title.modelEnumDef"
                  style="width: 100%"
                >
                  <template #append v-if="!isModelView">
                    <!-- 编辑枚举 -->
                    <compIconButton :auth="permissionObj" type="edit" icon="modify" color="#2684FC" @click="handleEnumEdit(row, $index)" slot="append" :divider="false" > </compIconButton>
                  </template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="address" :label="Lang.Title.modelCommuAddress">
              <template #default="{ row, $index }">
                <el-input
                  :disabled="isModelView"
                  v-model="modelForm.modelItemList[modelForm.modelItemList.findIndex(item => item.id == row.id)].comAddress"
                  :placeholder="Lang.tips.plzInput + Lang.Title.modelCommuAddress"
                  style="width: 100%"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="factor" :label="Lang.Title.modelCalFactir">
              <template #default="{ row, $index }">
                <el-input
                  :disabled="isModelView"
                  v-model="modelForm.modelItemList[modelForm.modelItemList.findIndex(item => item.id == row.id)].factor"
                  type="text"
                  :placeholder="Lang.tips.plzInput + Lang.Title.modelCalFactir"
                  style="width: 100%"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="measurementDescription" :label="Lang.Title.modelAction" v-if="!isModelView">
              <template #default="scope">
                <compIconButton
                  :auth="permissionObj"
                  type="delete"
                  :divider="false"
                  @click="handleDeleteMeasurementPoint(scope.$index, scope.row)"
                >
                  {{ Lang.btn.delete }}
                </compIconButton>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              v-model:current-page="selectedPointPage.currentPage"
              v-model:page-size="selectedPointPage.pageSize"
              :page-sizes="[10, 20, 30, 40, 50, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="selectedPointPage.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-row>
      </el-form>
      <div class="dialog-footer" v-if="operationType!='view'">
        <comp-button size="large" style="width: 120px;" @click="modelDialog = false">{{ Lang.btn.cancel }}</comp-button>
        <comp-button size="large" type="primary" style="width: 120px;" @click="handleSubmitMeasurementPoint()">{{ Lang.btn.confirm }}</comp-button>
      </div>
      <div class="dialog-footer" style="text-align: left;" v-if="operationType=='view' && modelForm.createTenant == userInfo.tenant_id">
        <comp-button size="large" type="primary" style="width: 120px;" @click="switchToEdit">{{ Lang.btn.edit }}</comp-button>
      </div>
    </el-drawer>

    <!-- 新增编辑模型弹框>新增枚举弹窗 -->
    <el-drawer
      :title="Lang.Title.modelEditEnumDef"
      append-to-body
      v-model="enumDialog"
      class="dataModel-selectpoints-dialog"
      size="70%"
    >
      <el-form-item>
        <EnumTable
          v-if="enumDialog"
          :enumTableData="enumTableData"
          :languageOptions="languageOptions"
          :isModelView="isModelView"
          @update:enumTableData="newData => (enumTableData = newData)"
        />
      </el-form-item>
      <div class="dialog-footer">
        <comp-button size="large" style="width: 120px;" @click="enumDialog = false">{{ Lang.btn.cancel }}</comp-button>
        <comp-button size="large" type="primary" style="width: 120px;" @click="handleEnumEditConfirm()">{{ Lang.btn.confirm }}</comp-button>
      </div>
    </el-drawer>

    <!-- 新增编辑选择测量点弹框 -->
    <el-drawer direction="rtl" size="80%" :title="Lang.Title.modelAddPoint" v-model="dataPointPage">
      <SelectMeasurementPoint :isView="isModelView" v-if="dataPointPage" ref="selectMeasurementPoint" :selectedPoints="selectedPoints" />
      <div style="display: flex; justify-content: center; margin-top: 40px; width: 100%">
        <comp-button size="large" type="default" style="width: 120px;" @click="dataPointPage = false">{{ Lang.btn.cancel }}</comp-button>
        <comp-button size="large" type="primary" style="width: 120px;" @click="onConfirmSelectPoints()">{{ Lang.btn.confirm }}</comp-button>
      </div>
    </el-drawer>

    <!-- 报警配置弹框 -->
     <div v-if="alarmConfigBox">
       <AlramConfigModel
         v-model="alarmConfigBox"
         @submit="handleSubmitAlarmConfig"
         @cancel="handleCancelAlarmConfig"
         :alarmList="alarmList"
         :modelId="modelId"
          :updateUser="updateUser"
         :languageOptions="languageOptions"
         :isView="isModelView"
         @update:alarmList="newData => (alarmList = newData)"
         ref="AlarmConfigModel"
       />
     </div>
  </basic-card>
</template>

<script>
import { update, add, } from '@/api/system/user';
import { getDictionary } from '@/api/system/dict';
import { getPage, remove, getItemLists } from '@/api/gateway/model';
import { submitModel, updateModel } from '@/api/gateway/measurementPoint';
import { alarmSetting, } from '@/api/gateway/data';
import { mapGetters } from 'vuex';
import website from '@/config/website';
import { getToken } from '@/utils/auth';
import func from '@/utils/func';
import { Lang } from '@/lang/lang';
import { filterDollarKeys } from '@/utils/util';
import { validatePass, validatePass2 } from '@/utils/validator';
import SelectMeasurementPoint from './comps/selectMeasurementPoint.vue';
import EnumTable from '@/views/gatewayManage/comps/enumTable.vue';
import { UN_SORT_LANGUAGE_OPTIONS } from '@/lang/language';
import AlramConfigModel from '@/views/gatewayManage/comps/alarmConfigTable.vue';
import { itemAlarmPage } from '@/api/gateway/measurementPoint';
import { cloneDeep } from 'lodash';

export default {
  components: {
    SelectMeasurementPoint,
    EnumTable,
    AlramConfigModel,
  },
  data() {
    return {
      token: getToken(),
      alarmConfigBox: false,
      operationType: '',
      tableKey: 0,
      modelId: null,
      languageOptions: UN_SORT_LANGUAGE_OPTIONS,
      paginatedModelItemList: [], // 过滤后的数据
      modelId: '', // 传给测量点数据
      modelForm: {
        iotProduct: '',
        measurementPoint: '',
        measurementPointIds: '',
        modelItemList: [], // 原始数据
      },
      form: {},
      search: {},
      modelDialog: false,
      enumDialog: false,
      isModelView: false,
      showMore: true,
      dataPointPage: false,
      initFlag: true,
      auditMode: false,
      selectedPoints: [],
      selectionList: [],
      deviceTypeList: [],
      deviceTypeCodeList: [],
      protocolList: [],
      alarmList: [],
      updateUser: '', // 告警更新 人
      enumTableData: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      tableData: [], // 已选的测点数据
      selectedPointPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      pointPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      props: {
        label: 'title',
        value: 'key',
      },
      treeDeptId: '',
      rules: {
        name: [
          { required: true, message: this.Lang.tips.plzInput + this.Lang.Title.modelModel, trigger: 'blur' },
        ],
        iotProduct: [{ required: true, message: this.Lang.tips.plzSelect + this.Lang.Title.modelDeviceType, trigger: 'blur' }],
        protocol: [{ required: false, message:  this.Lang.tips.plzSelect + this.Lang.Title.modelCommuProtocol, trigger: 'blur' }],
        manufacturer: [{ required: false, message: this.Lang.tips.plzInput + this.Lang.Title.modelManufacturer, trigger: 'blur' }],
        des: [{ required: false, message: this.Lang.tips.plzInput + this.Lang.Title.modelDescription, trigger: 'blur' }],
      },
      option: {
        height: 'auto',
        calcHeight: 'auto', // 表格的高度增加量，默认为自动高度。如果设置为auto，会自适应窗口高度。
        tip: false,
        searchShow: true, // 搜索栏
        searchSpan: 4, // 搜索栏的宽度
        searchMenuSpan: 6,
        // searchLabelPosition: 'top',
        searchLabelWidth: 'auto',
        gutter: 12,
        border: false, // 每行的竖线
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        selection: false, // 选择
        menuWidth: 186, // 操作列宽
        emptyBtn: false,
        searchBtn: false,
        addBtn: false, // 添加
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        // menuLabelClassName: 'operation-col-header', // 右对齐
        dialogType: 'drawer', // dialog drawer
        dialogClickModal: false,
        dialogMenuPosition: 'center', // 弹窗按钮位置
        updateBtnText: this.Lang.btn.add,
        emptyBtnText: this.Lang.btn.empty,
        labelPosition: 'top',
        showOverflowTooltip: true,
        column: [
          // 表格列
          {
            label: this.Lang.label.modelName,
            prop: 'name',
            search: true,
            display: false,
          },
          {
            label: this.Lang.table.modelId,
            prop: 'id',
            search: false,
            hide: false,
            display: false,
          },
          {
            label: this.Lang.Title.modelDeviceType,
            prop: 'iotProduct',
            search: true,
            slot: false, // 自定义内容格式化
            display: false,
            display: false,
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=iotProduct',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
          },
          {
            label: this.Lang.Title.modelCommuProtocol,
            prop: 'protocol',
            search: true,
            display: false,
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=protocol',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
          },
          {
            label: this.Lang.Title.modelManufacturer,
            prop: 'manufacturer',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.modelPoint,
            prop: 'pointCount',
            slot: false,
            display: false,
          },
          {
            label: this.Lang.Title.modelAlarm,
            prop: 'alarmCount',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.modelPic,
            prop: 'picture',
            type: 'image',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.modelDescription,
            prop: 'des',
            search: false,
            display: false,
          },
          {
            label: this.Lang.label.operator,
            prop: 'updateUserName',
            search: false,
            display: false,
          },
          {
            label: this.Lang.Title.modelUpdatedTime,
            prop: 'updateTime',
            search: false,
            display: false,
          },
        ],
        group: [
          // 新增弹出的form及校验
          {
            label: this.Lang.label.gatewayInfo,
            prop: 'gatewayInfo',
            // icon: 'el-icon-user-solid',
            labelPosition: 'top',
            labelTipPlacement: 'top-start',
            labelWidth: '120px',
            column: [
              {
                label: this.Lang.table.gatewayId,
                prop: 'tenantId',
                type: 'tree',
                dicUrl: '/blade-system/tenant/select',
                props: {
                  label: 'tenantName',
                  value: 'tenantId',
                },
                hide: !website.tenantMode,
                addDisplay: website.tenantMode,
                editDisplay: website.tenantMode,
                viewDisplay: website.tenantMode,
                rules: [
                  {
                    required: true,
                    message: this.Lang.tips.inputGatewayId,
                    trigger: 'click',
                  },
                ],
                span: 12,
              },
              {
                label: this.Lang.table.gatewayName,
                prop: 'account',
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.inputLoginAccount,
                    trigger: 'blur',
                  },
                ],
                span: 12,
              },
              {
                label: this.Lang.label.protocol,
                type: 'select',
                dicUrl: '/blade-system/dict/dictionary?code=user_type',
                props: {
                  label: 'i18nValue',
                  value: 'dictKey',
                },
                dataType: 'number',
                slot: true,
                prop: 'protocal',
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.plzSelectUserPlatform,
                    trigger: 'blur',
                  },
                ],
                span: 12,
              },
              {
                label: this.Lang.label.responseAddress,
                prop: 'password',
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, validator: validatePass, trigger: 'blur' }],
                span: 7,
              },
              {
                label: this.Lang.label.port,
                prop: 'password2',
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, validator: validatePass2, trigger: 'blur' }],
                span: 5,
              },
              {
                label: this.Lang.label.account,
                prop: 'password',
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, validator: validatePass, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.label.password,
                prop: 'password2',
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, validator: validatePass2, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.label.connectTimeout,
                type: 'select',
                dicUrl: '/blade-system/dict/dictionary?code=user_type',
                props: {
                  label: 'i18nValue',
                  value: 'dictKey',
                },
                dataType: 'number',
                slot: true,
                prop: 'protocal',
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.plzSelectUserPlatform,
                    trigger: 'blur',
                  },
                ],
                span: 12,
              },
              {
                label: this.Lang.label.belongToProject,
                type: 'select',
                dicUrl: '/blade-system/dict/dictionary?code=user_type',
                props: {
                  label: 'i18nValue',
                  value: 'dictKey',
                },
                dataType: 'number',
                slot: true,
                prop: 'protocal',
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.plzSelectUserPlatform,
                    trigger: 'blur',
                  },
                ],
                span: 12,
              },
            ],
          },
          {
            label: this.Lang.label.deviceInfo,
            prop: 'deviceInfo',
            // icon: 'el-icon-s-custom',
            column: [
              {
                label: this.Lang.table.deviceId,
                prop: 'deviceId',
              },
              {
                label: this.Lang.table.deviceName,
                prop: 'deviceName',
              },
              {
                label: this.Lang.label.portAddress,
                prop: 'portAddress',
              },

              {
                label: this.Lang.label.model,
                prop: 'model',
                type: 'tree',
                multiple: true,
                dicData: [],
                props: {
                  label: 'title',
                },
                checkStrictly: true,
                slot: true,
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.plzSelectModel,
                    trigger: 'click',
                  },
                ],
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['menuItem', 'permission', 'language', 'userInfo']),
    permissionObj() {
      const keys = Object.keys(this.permission);
      const obj = {};
      const menuId = this.menuItem.id;
      keys.forEach(key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
          obj.alarmSetting = true;
        }
      });
      return obj;
    },
  },
  mounted() {
    // 非租户模式默认加载管理组数据
    this.initData();
  },
  methods: {
    // 自定义删除
    handleDel(row) {
      console.log(row)
      if (row.rtuCount) {
        this.$dialog({
          title: this.Lang.Title.deviceDelDevice,
          titleStyle: 'font-weight:600;margin:10px 0 6px 0;',
          icon: 'warning',
          iconSize: '50px',
          iconColor: '#FEF3F2',
          content: this.Lang.Text.modelMustNotlink,
          confirmButtonText: this.Lang.btn.confirm,
          cancelButtonText: this.Lang.btn.cancel,
          cancelButtonType: 'default',
          confirmButtonType: 'primary',
          showClose: false,
          cancelButtonStyle: {
            width: '168px',
            height: '40px',
          },
          confirmButtonStyle: {
            width: '168px',
            height: '40px',
          }
        })
        return
      } else {
        this.$dialog({
          title: this.Lang.Title.deviceDelDevice,
          titleStyle: 'font-weight:600;margin:10px 0 6px 0;',
          icon: 'danger',
          iconSize: '50px',
          iconColor: '#FEF3F2',
          content: `<div style="color:red;margin:8px 0;">${this.Lang.Text.deviceDelDeviceCon}</div>`,
          confirmButtonText: this.Lang.btn.delete,
          cancelButtonText: this.Lang.btn.cancel,
          cancelButtonType: 'delete',
          confirmButtonType: 'danger',
          showClose: false,
        })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
      }
    },
    switchToEdit(flag) {
      this.operationType = 'edit';
      this.isModelView = false;
    },
    // 自定义搜索
    handleSearch() {
      console.log(this.search);
      const params = filterDollarKeys(this.search);
      this.onLoad(this.page, params);
    },
    // 前端已选的分页数据
    filterTableDataB(val) {
      this.filterTableData()
    },
    filterTableData() {
      // 获取搜索值并处理空格
      let searchValue = this.modelForm.measurementPoint?.toLowerCase() || '';
      let searchIdsStr = this.modelForm.measurementPointIds?.toLowerCase() || '';
      
      // 将逗号分隔的字符串拆分为数组，并去除空格和空值
      let searchIds = searchIdsStr
        .split(',')
        .map(item => item.trim())
        .filter(item => item !== '');

      searchValue = searchValue.trim(); // 去除搜索值的空格

      console.log('searchIds', searchIds, this.modelForm.modelItemList);

      // 过滤数据
      this.paginatedModelItemList = this.modelForm.modelItemList.filter((item) => {
        if (searchIds.length === 0 && searchValue.length === 0) {
          return true; // 如果没有搜索条件，则返回所有数据  
        }
        if (searchValue.length > 0 && searchIds.length > 0) {
          return (
            item.name?.toString().toLowerCase().includes(searchValue) ||
            (searchIds.includes(item.sid?.toString()) || // 按 sid 过滤
            searchIds.includes(item.id?.toString())) // 按 id 过滤
          );
        }
        if (searchValue.length > 0) {
          return (
            item.name?.toString().toLowerCase().includes(searchValue)
          );
        }
        if (searchIds.length > 0) {
          return (
            (searchIds.includes(item.sid?.toString()) || // 按 sid 过滤
            searchIds.includes(item.id?.toString())) // 按 id 过滤
          );

        }

      });
      console.log('过滤后的数据', this.paginatedModelItemList);

      // 更新分页数据
      this.selectedPointPage.total = this.paginatedModelItemList.length; // 更新分页总数
      this.selectedPointPage.currentPage = 1; // 重置到第一页
      this.updateSeletedPointsTableData();
    },
    handleSizeChange(size) {
      this.selectedPointPage.pageSize = size;
      this.selectedPointPage.currentPage = 1; // 重置到第一页
      this.updateSeletedPointsTableData();
    },
    handleCurrentChange(page) {
      this.selectedPointPage.currentPage = page;
      this.updateSeletedPointsTableData();
    },
    updateSeletedPointsTableData() {
      const start = (this.selectedPointPage.currentPage - 1) * this.selectedPointPage.pageSize;
      const end = start + this.selectedPointPage.pageSize;
      this.tableData = this.paginatedModelItemList.slice(start, end);
    },
    // 自定义清空
    handleEmpty() {
      this.$refs.crud.searchReset();
    },
    // 添加模型
    handleAddModel() {
      this.operationType = 'add',
      this.isModelView = false;
      this.modelForm = {
        id: null,
        name: '',
        iotProduct: '',
        protocol: '',
        manufacturer: '',
        des: '',
        measurementPoint: '',
        modelItemList: [],
      };
      this.tableData = [];
      this.selectedPoints = []
      this.modelForm.modelItemList = []; // 测量点列表
      this.resetPointPage()
      this.modelDialog = true;
    },
    resetPointPage() {
      this.selectedPointPage.currentPage = 1;
      this.selectedPointPage.pageSize = 10;
      this.selectedPointPage.total = 0;
    },
    // 告警设置
    handleAlarmSetting(row) {
      this.modelId = row.id;
      itemAlarmPage(1, 200, {modelId: row.id}).then((res) => {
        if (res.data.code === 200) {
          const data = res.data.data || {};
          this.updateUser = data.UpdateUser || ''
          const list = data.page.records || [];
          this.alarmList = list;
          this.isModelView = false;
          this.alarmConfigBox = true;
        }
      });
    },
    handleSubmitAlarmConfig(form, done) {
      const list = this.alarmList || [];
      const params = [];
      const modelId = this.modelId;
      list.map(item => {
        params.push({
          sid: item.sid,
          tenantId: item.tenantId,
          modelId: modelId,
          name: item.name,
          alarmType: item.alarmType,
          alarmLevel: item.alarmLevel,
          alarmVal: item.alarmVal,
        });
      });
      alarmSetting(modelId, params).then(
        () => {
          this.$message({
            type: 'success',
            message: this.Lang.tips.configSucceed,
          });
          this.alarmConfigBox = false;
        },
        error => {
          window.console.log(error);
        }
      );
    },
    handleCancelAlarmConfig() {
      this.alarmConfigBox = false;
      this.modelId = null;
    },

    // 添加或编辑测量点
    handleAddMeasurementPoint() {
      const form = this.modelForm;
      if (!form.name) {
        return this.$message.error(this.Lang.tips.plzInput + this.Lang.Title.modelModel);
      }
      if (!form.iotProduct) {
        return this.$message.error(this.Lang.tips.plzSelect + this.Lang.Title.modelDeviceType);
      }
      // if (!form.protocol) {
      //   return this.$message.error(this.Lang.tips.plzSelect + this.Lang.Title.modelCommuProtocol);
      // }
      form.modelItemList.forEach(item => {
        if (!item.sid && item.id && item.id.length == 6) {
          item.sid = item.id;
        }
      });
      this.pointPage.total = 0;
      this.pointPage.currentPage = 1;
      this.dataPointPage = true;
      
    },
    // 确认选择测量点
    async onConfirmSelectPoints() {
      const selectedPoints = this.$refs.selectMeasurementPoint.getSelectedPoints();
      if (!selectedPoints.length) {
        this.$message.error(this.Lang.tips.plzSelect + this.Lang.label.dataItem)
        return
      }
      this.selectedPoints = [...this.selectedPoints, ...selectedPoints];
      this.modelForm.modelItemList = this.selectedPoints;

      const form = this.modelForm;
      form.modelItemList.forEach(item => {
        if (!item.sid && item.id) {
          if (item.id.length === 6) {
            item.sid = item.id;
          }
        }
      });
      const modelItemList = this.selectedPoints;
      this.$message({
        type: 'success',
        message: this.Lang.tips.operationSuccess,
      });
      this.paginatedModelItemList = modelItemList || [];
      this.selectedPointPage.currentPage = 1;
      this.selectedPointPage.total = modelItemList.length;
      this.tableData = modelItemList;
      this.selectedPoints = modelItemList; // 更新用于禁用
      this.dataPointPage = false;
      this.updateSeletedPointsTableData();
      this.selectedPointPage.total = this.selectedPoints.length;
      this.selectedPointPage.currentPage = 1;
      
    },
    // 删除测量点
    handleDeleteMeasurementPoint(index, row) {
      const realIndex = this.modelForm.modelItemList.findIndex(item => item.id == row.id);
      this.modelForm.modelItemList.splice(realIndex, 1);
      this.selectedPoints = this.modelForm.modelItemList; // 更新用于禁用
      this.paginatedModelItemList = this.modelForm.modelItemList;
      this.selectedPointPage.total = this.paginatedModelItemList.length;
      this.updateSeletedPointsTableData();
    },
    // 提交测点
    handleSubmitMeasurementPoint() {
      const form = this.modelForm;
      if (!form.name) {
        return this.$message.error(this.Lang.tips.plzInput + this.Lang.Title.modelModel);
      }
      if (!form.iotProduct) {
        return this.$message.error(this.Lang.tips.plzSelect + this.Lang.Title.modelDeviceType);
      }
      form.modelItemList.forEach(item => {
        if (!item.sid && item.id && item.id.length == 6) {
          item.sid = item.id;
        }
      });
      const submitFn = this.operationType == 'edit' ? updateModel : submitModel;

      submitFn(form).then(
        () => {
          this.initFlag = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.modelDialog = false;
        },
        error => {
          window.console.log(error);
        }
      );
    },
    // 为所有企业复制该型号
    handleDuplicate(row) {
      this.handleModelEditOrView(row, 'add', true);
    },
    // 模型编辑
    async handleModelEditOrView(row, type, duplicate) {
      this.operationType = type;
      this.isModelView = type === 'view';
      this.selectedPoints = [] // 清空已选禁用的
      this.modelForm.id = row.id;
      const data = await this.getMeasurementPointList(row.id);
      if (type !== 'add') {
        this.getDeviceTypeCode(row.iotProduct);
      }
      

      const measurementPoints = data || []; // 前端临时存储的枚举列表
      
      this.selectedPoints = measurementPoints;
      // console.log('handleModelEditOrView measurementPoints', measurementPoints);
      if (measurementPoints.length) {
        measurementPoints.forEach(item => {
          if (item.id && item.id.length == 6) {
            item.sid = item.id;
          }
          // 如果有枚举列表，则将枚举列表赋值给itemEnumList
          const itemEnumList = item.itemEnumList || [];
          const packLanguageKey = import.meta.env.VITE_APP_LANGUAGE;
          
          if (itemEnumList && itemEnumList.length) {
            item.itemEnumList = itemEnumList.map(item => {
              const obj = {
                ...item,
              };
              obj['zh-CN'] = item.name;
              obj['en-US'] = item.enName;
              if (!obj[packLanguageKey]) {
                obj[packLanguageKey] = item.enName;
              }

              UN_SORT_LANGUAGE_OPTIONS.forEach(lang => {
                obj[lang.key] = item[lang.key];
              });
              return obj;
            });
          } else {
            item.itemEnum = ''; // 如果没有枚举列表，则将itemEnum赋值为空
          }
        });
        
      }
      this.modelForm = cloneDeep(row);
      if (duplicate) { // 清空id和名字
        this.modelForm.id = null;
        this.modelForm.name = '';
      }
      this.modelForm.modelItemList = measurementPoints;
      this.paginatedModelItemList = [...this.modelForm.modelItemList];
      this.modelDialog = true;
    },
    // 新增枚举弹窗
    handleEnumEdit(row, index) {
      this.currentEditRow = row;
      this.currentEditIndex = index;
      console.log('handleEnumEdit', row, index);
      let itemEnumList = row._frontendItemEnumList || [];
      if (!itemEnumList.length) {
        itemEnumList = row.itemEnumList || []
      }
      if (itemEnumList.length) {
        const newList = []
        itemEnumList.map(item => {
          item['zh-CN'] = item.name;
          item['en-US'] = item.enName;
          const packLanguageKey = import.meta.env.VITE_APP_LANGUAGE;
          item[packLanguageKey] = item.localName;
          
          if (!item.localName) {
            item[packLanguageKey] = item.enName;
          }
          if (!item['zh-CN']) {
            item['zh-CN'] = item.enName;
          }

          const obj = {
            ...item,
          };
  
          UN_SORT_LANGUAGE_OPTIONS.forEach(lang => {
            obj[lang.key] = item[lang.key];
          });
          
          newList.push(obj);
        });
        console.log('编辑带出enumTableData', newList)
        this.enumTableData = newList;
      } else {
        this.enumTableData = []; // 从编辑第一行切换编辑第二行
      }
      this.enumDialog = true;
    },
    // 获取模型编辑里的测量点数据列表，前端分页
    async getMeasurementPointList() {
      const res = await getItemLists(this.selectedPointPage.currentPage, this.selectedPointPage.pageSize, { modelId: this.modelForm.id });
      if (res.data.code !== 200) {
        this.$message.error(res.data.msg);
        return;
      }
      const data = res.data.data || [];
      const measurementPoints = data || []; // 前端临时存储的枚举列表
      this.modelForm.modelItemList = measurementPoints;
      this.paginatedModelItemList = [...this.modelForm.modelItemList];
      this.selectedPointPage.total = data.length || 0;
      this.selectedPointPage.currentPage = 1;
      this.selectedPointPage.pageSize = 10;
      this.updateSeletedPointsTableData();
      return data;
    },
    // 确认编辑枚举
    handleEnumEditConfirm() {
      const itemEnumList = []
      let validate = true;
      let validateParameter = true;
      console.log(this.enumTableData, 'enumTableData')
      this.enumTableData.map(item => {
        if (!item['en-US']) {
          validate = false;
        }
        if (!/^[0-9]+$/.test(item.parameter)) {
          validateParameter = false;
        }
        
        const packLanguageKey = import.meta.env.VITE_APP_LANGUAGE;
        console.log('packLanguageKey', packLanguageKey)
        const row = {
          ...item, // 保留其他属性方便再次编辑
          name: item['zh-CN'], // 如果没有中文把英文赋值
          enName: item['en-US'],
          localName: item[packLanguageKey],
        }
        if (!row.name) {
          row.name = row.enName;
        }
        if (!row.localName) {
          row.localName = row.enName;
        }
        itemEnumList.push(row);
      });
      console.log('确认编辑后的itemEnumList', itemEnumList)
      if (!validateParameter) {
        return this.$message.error(Lang.Title.standardPointParam + ' ' +this.Lang.tips.limit0Int);
      }
      if (!validate) {
        return this.$message.error(this.Lang.tips.plzInput + 'Name_US');
      }
      
      this.modelForm.modelItemList[this.currentEditIndex].itemEnumList = itemEnumList;
      this.modelForm.modelItemList[this.currentEditIndex].itemEnum = this.enumTableData.map(item => item.parameter).join(',');
      this.modelForm.modelItemList[this.currentEditIndex]._frontendItemEnumList = itemEnumList;
      this.enumDialog = false;
    },
    handleAvatarSuccess(response, uploadFile) {
      this.modelForm.picture = response.data.link;
    },
    beforeAvatarUpload(rawFile) {
      if (!['image/png', 'image/jpg', 'image/jpeg'].includes(rawFile.type)) {
        ElMessage.error('Avatar picture must be png、JPG、jpeg format!');
        return false;
      } else if (rawFile.size / 1024 / 1024 > 5) {
        ElMessage.error('Avatar picture size can not exceed 5MB!');
        return false;
      }
      return true;
    },
    handleRemove() {
      this.modelForm.picture = '';
    },
    initData() {
      getDictionary({ code: 'iotProduct' }).then(res => {
        this.deviceTypeList = res.data.data;
      });
      getDictionary({ code: 'protocol' }).then(res => {
        this.protocolList = res.data.data;
      });
    },
    getDeviceTypeCode(val) {
      getDictionary({ code: val }).then(res => {
        this.deviceTypeCodeList = res.data.data;
      });
    },
    rowSave(row, done, loading) {
      row.deptId = func.join(row.deptId);
      row.roleId = func.join(row.roleId);
      row.postId = func.join(row.postId);
      add(row).then(
        () => {
          this.initFlag = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      row.deptId = func.join(row.deptId);
      row.roleId = func.join(row.roleId);
      row.postId = func.join(row.postId);
      update(row).then(
        () => {
          this.initFlag = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    searchReset() {
      this.query = {};
      this.treeDeptId = '';
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      if (list.length > 1) {
        const newVal = list.shift();
        this.$refs.crud.toggleRowSelection(newVal, false);
      }
      this.selectionList = list;
      if (list[0]) {
        const modelId = list[0].id;
        this.modelId = modelId;
      } else {
        this.modelId = '';
      }
      // this.$refs.DataModelB.loadData(this.modelId);
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data.data;
          if (this.form.hasOwnProperty('deptId')) {
            this.form.deptId = func.split(this.form.deptId);
          }
          if (this.form.hasOwnProperty('roleId')) {
            this.form.roleId = func.split(this.form.roleId);
          }
          if (this.form.hasOwnProperty('postId')) {
            this.form.postId = func.split(this.form.postId);
          }
        });
      }
      this.initFlag = true;
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getPage(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query, { status: this.auditMode ? 0 : 1 }),
        this.treeDeptId
      ).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.modelId = this.data[0]?.id;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style lang="scss">
.avatar-uploader {
  img {
    width: 60px;
    height: 60px;
  }
}</style>
